import { SocialLinksEnum as r } from "../enums/social-links-enum.mjs";
const u = (t) => {
  switch (t.type) {
    case r.instagram:
      return "https://www.instagram.com/" + t.url;
    case r.twitter:
      return "https://twitter.com/" + t.url;
    case r.tiktok:
      return "https://www.tiktok.com/@" + t.url;
    case r.telegram:
      return "https://t.me/" + t.url;
    case r.email:
      return "mailto:" + t.url;
    default:
      return t.url;
  }
};
export {
  u as normalizeSocialLink
};
